import React, { useEffect, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import Axios from "axios";
import url from "../../services/url";
import LoadingArea from "../../components/LoadingArea";
import CandidatesTable from "../../components/CandidatesTable";
import requestHeaders from "../../services/requestHeaders";
import isConsultant from "../../services/isConsultant";

function CandidatesAssigned() {
  // States
  const [loading, setLoading] = useState(true);
  const [candidates, setCandidates] = useState([]);

  const [AppPage,setAppPage]=useState(1)
  const [formIds, setFormIds] = useState("")
  const [Input,setInput] = useState("");
  const [LengthPages,setLengthPages] = useState();
  const [locationName, setLocationName] = useState("")
  const [candidateStatus, setCandidateStatus] = useState("")
  const [processId, setProcessId] = useState("")
  const [count, setCount] = useState(0)
  const [startDates, setStartDates] = useState("")
  const [endDates, setEndDates] = useState("")





  // Effects
  useEffect(() => {
    Axios.get(url("candidates/assigned"), requestHeaders(),{
      headers:{
        Authorization: `Bearer ${localStorage.getItem("user.token")}`
      }})
      .then((res) => {
        setCandidates(res.data);
        setLoading(false);
      })
      .catch(console.error);
  }, []);

  return (
    <div>
    {!isConsultant() && <Dashboard title="Assigned Candidates (Interviews Remaining)">
      <LoadingArea isLoading={loading}>
        <CandidatesTable candidates={candidates} setCandidates={setCandidates}

        setLocationName={setLocationName}
          locationName={locationName}

          setCandidateStatus={setCandidateStatus}
          candidateStatus={candidateStatus}
          setFormIds={setFormIds}
          formIds={formIds}
          setProcessId={setProcessId}
          processId={processId}
        startDates={startDates}
        setStartDates={setStartDates}
        endDates={endDates}
        setEndDates={setEndDates}
        setInput={setInput}
        setAppPage={setAppPage}
        />
      </LoadingArea>
    </Dashboard>}
    </div>
  );
}

export default CandidatesAssigned;
